import './Footer.css'
import cx from "classnames";
import { connect } from "react-redux";


const Footer = ({ activeDarkMode}) => {
  return (
    <footer className={cx(
            "footer",
            {"footer-white": !activeDarkMode},
            {"dark-theme": activeDarkMode},
          )}>
        Assembled in London 🏴󠁧󠁢󠁥󠁮󠁧󠁿
    </footer>
  )
}

const mapStateToProps = state => {
  return { activeDarkMode: state.counter.darkMode };
};

export default connect(
  mapStateToProps
)(Footer);